import type {Location, Route} from 'vue-router';

export class RoutingUtils {
	public static generateLocationFromRoute(route: Route): Location {
		// pick properties from Route needed to define Location
		const {
			name,
			path,
			hash,
			query,
			params,
		} = route;

		const location: Location = {
			path,
			hash,
			query,
			params,
		};

		if(name) {
			location.name = name;
		}

		return location;
	}
}
